/* BENYAR Product Image Coverflow — syncs a 3D image selector to Shopify's native Slideshow. */
(function(){
  'use strict';
  function initialize(gallery){
    var root=gallery.querySelector('[data-bny-pdp-cf]');
    if(!root||root.dataset.ready==='1')return;
    var stage=root.querySelector('[data-bny-cf-stage]');
    var slideshow=gallery.querySelector('slideshow-component');
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-bny-cf-photo]'));
    if(!stage||!slideshow||cards.length<2)return;
    root.dataset.ready='1';
    var current=0,lastTouch=null,suppressClickUntil=0;
    var counter=root.querySelector('[data-bny-cf-current]');
    function paint(index){
      var count=cards.length;
      current=(index%count+count)%count;
      cards.forEach(function(card,i){
        var diff=(i-current+count)%count;
        if(diff>count/2)diff-=count;
        var pos=Math.abs(diff)<=2?String(diff):'hidden';
        card.setAttribute('data-position',pos);
        card.setAttribute('aria-pressed',String(i===current));
        card.tabIndex=(Math.abs(diff)<=2)?0:-1;
      });
      if(counter)counter.textContent=String(current+1).padStart(2,'0');
    }
    function go(index){
      if(!cards.length)return;
      var next=(index%cards.length+cards.length)%cards.length;
      paint(next);
      if(typeof slideshow.select==='function')slideshow.select(next,undefined,{animate:true});
    }
    root.addEventListener('click',function(e){
      var button=e.target.closest('[data-bny-cf-photo]');
      if(button){
        if(Date.now()<suppressClickUntil){e.preventDefault();return;}
        var index=Number(button.dataset.index);
        if(!Number.isNaN(index))go(index);
        return;
      }
      if(e.target.closest('[data-bny-cf-prev]'))go(current-1);
      if(e.target.closest('[data-bny-cf-next]'))go(current+1);
    });
    root.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
        e.preventDefault();
        go(current+(e.key==='ArrowRight'?1:-1));
      }
    });
    stage.addEventListener('pointerdown',function(e){
      if(e.isPrimary===false)return;
      lastTouch={x:e.clientX,y:e.clientY};
    },{passive:true});
    stage.addEventListener('pointerup',function(e){
      if(!lastTouch)return;
      var dx=e.clientX-lastTouch.x,dy=e.clientY-lastTouch.y;
      lastTouch=null;
      if(Math.abs(dx)>34&&Math.abs(dx)>Math.abs(dy)*1.3){
        suppressClickUntil=Date.now()+300;
        go(current+(dx<0?1:-1));
      }
    },{passive:true});
    stage.addEventListener('pointercancel',function(){lastTouch=null;},{passive:true});
    slideshow.addEventListener('slideshow:select',function(event){
      if(event.target!==slideshow)return;
      var i=event.detail&&Number(event.detail.index);
      if(Number.isInteger(i)&&i>=0&&i<cards.length)paint(i);
    });
    paint(0);
  }
  function scan(){document.querySelectorAll('media-gallery').forEach(initialize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('shopify:section:load',scan);
  var pending=false;
  var observer=new MutationObserver(function(mutations){
    var changed=mutations.some(function(m){
      for(var i=0;i<m.addedNodes.length;i++){
        var n=m.addedNodes[i];
        if(n.nodeType===1&&(n.matches?.('media-gallery')||n.querySelector?.('media-gallery')))return true;
      }
      return false;
    });
    if(!changed||pending)return;
    pending=true;
    requestAnimationFrame(function(){pending=false;scan();});
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();